import { useQuery } from '@tanstack/react-query';
import adminInventoryService from '../../services/adminInventoryService';

export const useSelectWarehouse = (supplierId) => {
  return useQuery({
    queryKey: ['admin-inventory-warehouses', supplierId],
    queryFn: () => adminInventoryService.getSupplierWarehouses(supplierId),
    enabled: !!supplierId,
    staleTime: 1000 * 60 * 5,
  });
};
